import { render, staticRenderFns } from "./AppFilePicker.vue?vue&type=template&id=52d5e7c6&scoped=true"
import script from "./AppFilePicker.vue?vue&type=script&lang=js"
export * from "./AppFilePicker.vue?vue&type=script&lang=js"
import style0 from "./AppFilePicker.vue?vue&type=style&index=0&id=52d5e7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5e7c6",
  null
  
)

export default component.exports